module.exports = {
  title: 'Instagram Shared Element Transition with Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2024-02-28',
  slug: 'instagram-shared-transition',
  tags: ['reanimated', 'gesture-handler'],
};
